<template>
  <div class="mobile-navbar">
    <div class="m-container">
      <div class="overleay-mob" v-if="is_menu_open"></div>
      <div class="mobile-navbar-holder">
        <!-- button navbar -->
        <!-- This is your menu -->
        <menu class="menu" :class="{'menu--open': is_menu_open}">
          <ul>
            <li>
              <router-link class="link-item" to="/">home</router-link>
            </li>
            <li>
              <router-link to="/about-us">About</router-link>
            </li>
            <li>
              <router-link class="link-item" to="/competitions">competitions</router-link>
            </li>
            <li>
              <router-link class="link-item" to="/event">events</router-link>
            </li>
            <li>
              <router-link class="link-item" to="/training-support">Training & Support</router-link>
            </li>
            <li>
              <router-link class="link-item" to="/faq">FAQ</router-link>
            </li>
            <li>
                    <router-link to="/01-space">01Space</router-link>
                  </li>
            <li>
              <router-link class="link-item" to="/sign-in">{{ userState ? 'Profile' : 'Register & Login' }}
              </router-link>
            </li>
          </ul>
        </menu>
        <!-- This is your menu button -->
        <!-- It's loaded in the HTML after the menu -->
        <div class="row">
          <div class="col-4">
            <nav class="menu-btn"
                 :class="{'menu-btn--on': is_menu_open}"
                 @click="is_menu_open = !is_menu_open">
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </nav>
          </div>
          <div class="col-4">
            <!-- end button navbar -->
            <div class="the-logo">
              <img width="100" src="@/assets/img/logo/logo_h_2.png">
            </div>
          </div>
          <div class="col-4">
            <!-- user info ! if user is logged in -->
            <div class="user-info button-register" v-if="!userState">
              <div class="the-button">
                <router-link tag="button" to="/sign-In" class="wro-button"><span>Register/Login</span></router-link>
                <span class="skew-line"></span>
              </div>
            </div>
            <div class="user-info" v-else>
              <div class="user-img">
                <img :src="userData.image" v-if="userData.image !== null">
                <img src="@/assets/img/user/avatar_profile.png" v-else>
              </div>
              <div class="user-option">
                <q-btn-dropdown icon="fas fa-bell">
                  <q-list class="notifications-list">
                    <q-item>
                      Notifications
                    </q-item>
                    <q-item class="single-notification" clickable v-close-popup>
                      <q-item-section>
                        <img src="@/assets/img/user/avatar_profile.png" alt="">
                        <div>
                          <p class="notification-title">You will get only notification what have </p>
                          <p class="notification-time">since 5 minutes ago</p>
                        </div>
                      </q-item-section>
                    </q-item>

                    <q-item class="single-notification" clickable v-close-popup>
                      <q-item-section>
                        <img src="@/assets/img/user/avatar_profile.png" alt="">
                        <div>
                          <p class="notification-title">You will get only notification what have </p>
                          <p class="notification-time">since 5 minutes ago</p>
                        </div>
                      </q-item-section>
                    </q-item>

                    <q-item clickable v-close-popup>
                      <q-item-section>
                        <q-item-label>See all notifications</q-item-label>
                        <svg xmlns="http://www.w3.org/2000/svg" width="6.289" height="11" viewBox="0 0 6.289 11">
                          <path id="Icon_ionic-ios-arrow-back" data-name="Icon ionic-ios-arrow-back"
                                d="M15.644,11.692,11.481,7.533a.786.786,0,0,1,1.113-1.11l4.716,4.712a.785.785,0,0,1,.023,1.084L12.6,16.965a.786.786,0,0,1-1.113-1.11Z"
                                transform="translate(-11.251 -6.194)"/>
                        </svg>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </div>
            </div>
            <!-- end user info ! if user is logged in -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_menu_open: false,
    }
  },
  computed: {
    userState() {
      return this.$store.state.userState;
    },
    userData() {
      return this.$store.state.userData;
    }
  },
  watch: {
    '$route'() {
      this.is_menu_open = false
    }
  }
}
</script>

<style>
.mobile-navbar {
  display: none;
  position: sticky;
  top: 0px;
  height: 73px;
  background: var(--mainColors);
  z-index: 55;
}

.mobile-navbar .the-logo {
  display: flex;
  justify-content: left;
  height: 100%;
  align-content: center;
  align-items: center;
  height: 74px;
}

/* This just resets the styles of our unordered list that makes our hamburger/hotdog icon */
.mobile-navbar ul {
  list-style: none;
  padding: 0;
}

/* Styles for the menu button */
.mobile-navbar .menu-btn {
  background-color: var(--mainColors);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .16);
  cursor: pointer;
  height: 44px;
  position: absolute;
  top: 50%;
  width: 44px;
  transform: translate(0, -50%);
  z-index: 10;  
}
.mobile-navbar .menu-btn:focus { outline: none;}
/* Styles for the menu */
.mobile-navbar .menu {
  bottom: 0;
  background-color: var(--mainColors);
  left: 0;
  margin: 0;
  padding: 32px;
  position: fixed;
  top: 0;
  width: 288px;
  transform: translate3d(-100%, 0, 0);
  transition: transform .2s linear;
  z-index: 10;
}

.overleay-mob {
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh !important;
  background: #0000005c;
  z-index: 1 !important;
}

/* Creating the hamburger/hotdog icon in CSS */
.mobile-navbar .menu-btn li {
  background-color: #ffffff;
  bottom: 0;
  height: 2px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  width: 16px;
  top: 0;
  transition: all .3s ease-in-out;

}

.mobile-navbar .menu ul {
  margin-top: 50px;
}

.mobile-navbar .menu ul li {
  margin-bottom: 8px;
  border: 1px solid white;
  border-radius: 5px; 
  padding: 10px 15px;  
  background: white;
}
.mobile-navbar .menu ul li:hover{border: 1px solid white; background: transparent;}

.mobile-navbar .menu ul li a {
  color: var(--mainColors);
  text-transform: uppercase;
  display: block;
}
.mobile-navbar .menu ul li a:hover{ color: white;}

/* The following two lines set the three lines of our hamburger/hotdog icon apart */
.mobile-navbar .menu-btn li:first-child {
  transform: translate3d(0, -4px, 0);
}

.mobile-navbar .menu-btn li:last-child {
  transform: translate3d(0, 4px, 0);
}

/* We're now in the animation territory. These are the classes you toggle on with our Javascript function. */
.mobile-navbar .menu-btn--on li:first-child {
  transform: rotate(135deg) translate3d(0, 0, 0);
}

.mobile-navbar .menu-btn--on li:last-child {
  transform: rotate(-135deg) translate3d(0, 0, 0);
}

.mobile-navbar .menu-btn--on li:nth-child(2) {
  opacity: 0;
}

.mobile-navbar .menu--open {
  transform: translate3d(0, 0, 0);
}


.mobile-navbar .user-info {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  font-family: 'Tajawal', sans-serif;
  height: 100%;
}

.user-info .user-img {
  width: 47px;
  height: 47px;
  cursor: pointer;
  margin-left: 15px;
}

.user-info button-register {
  margin-right: 15px;
}

.user-info .user-img img {
  width: 100%;
  object-fit: cover;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
}

.user-info .user-name {
  margin: 0px 13px;
  cursor: pointer;
}

.user-info .user-name p {
  font-size: 0.813rem;
  font-weight: bold;
  color: #ffffff;
  cursor: pointer;
}

.user-option {
  display: flex;
}

.user-info .user-option div i {
  width: 26px;
  height: 26px;
  text-align: center;
  cursor: pointer;
}

.user-info .user-option div.arrow-down i {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: var(--mainColors);
  background: #ffffff !important;
  line-height: 2.5;
  font-size: 11px;
}

.user-info .user-option button {
  width: 44px;
  height: 44px;
  border-radius: 100%;
}

.user-info .user-option .fa-bell {
  font-size: 21px !important;
  color: #ffffff;
}

.user-info .q-btn__wrapper .q-btn-dropdown__arrow {
  display: none !important;
}

.the-header .q-btn__wrapper:before {
  box-shadow: none;
}

.user-info .user-option div:nth-child(2) {
  padding-left: 9px;
  border-left: 2px solid #ffffff;
  display: flex;
  align-items: center;
}

.user-info .user-option div:nth-child(1) {
  padding-right: 9px;
}


</style>